import { render, staticRenderFns } from "./MedicalNoteCategoryAdd.vue?vue&type=template&id=49020f29"
import script from "./MedicalNoteCategoryAdd.vue?vue&type=script&lang=js"
export * from "./MedicalNoteCategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./MedicalNoteCategoryAdd.vue?vue&type=style&index=0&id=49020f29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports